export default {
  placeholder: 'Indiferente',
  selected: 'seleccionado',
  selectedPlural: 'seleccionados',
};
